import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IJobSearchPageContent } from '../models/content'
import { IJobSearchAppState } from '../index';
//import { Pagination } from './pagination/pagination';
import * as _ from 'lodash';
import { IJobSearchResults, IJobSearchResult, IJobSearchRequest, } from '../../global/DTO/job-search';
import { FetchPendingAction } from '../../global/middleware/fetch-middleware';
import { SearchError } from './error';
import { ResultList } from './results/result-list';
import { getJobSearchResults, DefaultJobSearchResults } from '../../global/ducks/job-search-api';
import { getContentProps } from '../../global/ducks/content-api';
import { Pagination } from '../../global/components/pagination/pagination';
import { JobSearchFilters } from './filters';
import { ResultCount } from './results/result-count';
import { Helpers } from "../../global/functions/helpers";

// Regular page nav to support header skip
import { nav } from '../../../typescript/inits/navigation';

interface IStateProps {
    contentProps: IJobSearchPageContent,
    jobSearchResults: IJobSearchResults,
}

interface IDispatchProps {
    getContentProps: () => FetchPendingAction;
    getSearchResults: (criteria: IJobSearchRequest) => FetchPendingAction;
}

interface IOwnProps {
    contentId: string;
    cities: string[];
    businessAreas: string[];
    states: string[];
    countries: string[];
    dateSortRelevanceFilter: number;
    setQueryParams: (params: { [key: string]: string[] }) => void
    initialParams: { [key: string]: string[] }
}

type IProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    pageSize: number;
    searchText: string;
    pageNumber: number;
    isLoading: boolean;
    hasSearched: boolean;
    fetchError: boolean;
    city: string;
    businessArea: string;
    state: string;
    country: string;
    pageContentRef: React.RefObject<HTMLHeadingElement>;
    keywordInputRef: React.RefObject<HTMLInputElement>;
    resultsHeadingRef: React.RefObject<HTMLHeadingElement>;
}

export class JobSearch extends React.Component<IProps, IState> {
    static defaultProps = {
        contentProps: {},
        jobSearchResults: DefaultJobSearchResults,
    }
    constructor(props) {
        super(props);

        const searchText = props.initialParams.q && decodeURIComponent(props.initialParams.q[0]) || '';
        delete props.initialParams.q;

        const pageNumber = props.initialParams.pageNumber && +props.initialParams.pageNumber[0] || 1;
        delete props.initialParams.pageNumber;

        const city = props.initialParams.city && decodeURIComponent(props.initialParams.city[0]) || '';
        delete props.initialParams.city;

        const state = props.initialParams.state && decodeURIComponent(props.initialParams.state[0]) || '';
        delete props.initialParams.state;

        const country = props.initialParams.country && decodeURIComponent(props.initialParams.country[0]) || '';
        delete props.initialParams.city;

        const businessArea = props.initialParams.businessArea && decodeURIComponent(props.initialParams.businessArea[0]) || '';
        delete props.initialParams.businessArea;

        const pageContentRef = React.createRef<HTMLHeadingElement>();
        const keywordInputRef = React.createRef<HTMLInputElement>();
        const resultsHeadingRef = React.createRef<HTMLHeadingElement>();

        this.state = {
            searchText,
            pageSize: props.contentProps.pageSize,
            pageNumber,
            isLoading: false,
            hasSearched: false,
            fetchError: false,
            city,
            state,
            country,
            businessArea,
            pageContentRef,
            keywordInputRef,
            resultsHeadingRef
        };
    }

    componentDidMount() {
        this.props.getContentProps();
        this.getJobSearchResults();
    }

    render() {
        const { contentProps, jobSearchResults, cities, businessAreas, states, countries } = this.props;

        return (
            <>
                <section className="header-block hero-block">
                    <div className="hero">
                        <div className="hero-heading-container">
                            <div className="hero-image-mobile split-image-container keyword-hero-image-container" style={{ backgroundImage: `url('${contentProps.imageUrl}')` }}>
                                <div className="hero-image-picture split-image-picture">
                                    <img src={contentProps.imageUrl} alt={contentProps.imageAltText} className="split-image" />
                                </div>
                            </div>
                            <div className="keyword-hero-content">
                                <h1 dangerouslySetInnerHTML={{ __html: Helpers.stripParagraphTags(contentProps.header) }}></h1>
                                <form className="keyword-hero-form" onSubmit={this.applySearchText}>
                                    <label htmlFor="search-text">{contentProps.searchTextboxLabel}</label>
                                    <div className="inline-input-btn keyword-hero-fields">
                                        <div className="keyword-hero-input-wrapper">
                                            <input className="form-item-xl keyword-hero-input" type="text" placeholder={contentProps.searchTextboxPlaceholder} id="search-text" value={this.state.searchText} onChange={this.onSearchTextChange} ref={this.state.keywordInputRef} />
                                            {this.state.searchText && this.state.searchText.length > 0 &&
                                                <button type="button" className="btn-icon btn-x keyword-hero-x" onClick={this.clearSearchText}>
                                                    &nbsp;
                                            <span className="visually-hidden">Clear input</span>
                                                </button>
                                            }
                                        </div>
                                        <button type="submit" className="btn-icon btn-search keyword-hero-search">
                                            &nbsp;
                                        <span className="visually-hidden">Submit</span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="hero-image-container split-image-container" style={{ backgroundImage: `url('${contentProps.imageUrl}')` }}>
                            <div className="hero-image-picture split-image-picture">
                                <img src={contentProps.imageUrl} alt={contentProps.imageAltText} className="split-image" />
                            </div>
                        </div>
                    </div>
                    <div className="keyword-hero-scroll-container">
                        <a href="#pageContent" className="hero-scroll keyword-hero-scroll" onClick={this.headerSkip}>
                            <svg className="svg-icon hero-scroll-icon" aria-hidden="true" focusable="false">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-scroll-arrow" />
                            </svg>
                            <span className="visually-hidden">Page content</span>
                        </a>
                    </div>
                </section>
                {this.state.fetchError &&
                    <SearchError
                        errorText={contentProps.searchErrorText}
                    />
                }
                <h2 tabIndex={-1} id="pageContent" className="skip-target skip-target-spaced" ref={this.state.pageContentRef}>
                    <span className="visually-hidden">Browse Open Positions</span>
                </h2>
                <div data-blocks>
                    <section className="results-container">
                        <JobSearchFilters
                            businessAreas={businessAreas}
                            selectedBusinessArea={this.state.businessArea}
                            cities={cities}
                            selectedCity={this.state.city}
                            content={contentProps}
                            states={states}
                            selectedState = {this.state.state}
                            countries={countries}
                            selectedCountry={this.state.country}
                            onCityChange={this.setCity}
                            onStateChange = {this.setStateValue}
                            onBusinessAreaChange={this.setBusinessArea}
                            onCountryChange={this.setCountry}
                        />
                        <div className={`results-panel stack-lg space-top-xl ${jobSearchResults.totalResults > 0 ? '' : 'no-results'}`}>
                            <h3 className="visually-hidden" tabIndex={-1} id="Search_heading" ref={this.state.resultsHeadingRef}>Results</h3>
                            {
                                jobSearchResults.totalResults > 0 ?
                                    <>
                                        <div className="block-inner">
                                            <div className="flex-between pagination-header">
                                                <ResultCount
                                                    resultCountText={contentProps.resultCountText}
                                                    totalResults={jobSearchResults.totalResults} />
                                                <Pagination
                                                    totalItems={jobSearchResults.totalResults}
                                                    pageSize={this.state.pageSize}
                                                    pageNumber={this.state.pageNumber}
                                                    onPageSelect={(pageNumber) => this.setPageNumber(pageNumber)}
                                                    pageText={contentProps.pageText}
                                                />
                                            </div>
                                        </div>
                                        <div className="block-inner">
                                            <ResultList
                                                results={jobSearchResults.results}
                                                onResultClick={this.onResultClick}
                                                content={contentProps} />
                                            <div className="pagination-footer">
                                                <Pagination
                                                    totalItems={jobSearchResults.totalResults}
                                                    pageSize={this.state.pageSize}
                                                    pageNumber={this.state.pageNumber}
                                                    onPageSelect={(pageNumber) => this.setPageNumber(pageNumber)}
                                                    pageText={contentProps.pageText}
                                                />
                                            </div>
                                        </div>
                                    </>
                                    :
                                    this.state.isLoading ?
                                        <div className="block">
                                            <div className="block-inner">
                                                <div className="loading-indicator-container">
                                                    <p className="loading-indicator">Loading results...</p>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="block-inner">
                                            <div className="rich-text" dangerouslySetInnerHTML={{ __html: contentProps.noResultsText }}></div>
                                        </div>
                            }
                        </div>
                    </section>
                </div>
            </>
        )
    }

    onSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setSearchText(e.target.value);
    }

    setSearchText = (searchText: string) => {
        this.setState({ searchText: searchText });
    }

    applySearchText = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        this.onUpdateQuery();
        this.getJobSearchResults();
        this.scrollToResults();
    }

    clearSearchText = (e: React.MouseEvent<HTMLButtonElement>) => {
        this.setState({ searchText: '' }, () => {
            this.onUpdateQuery();
            this.getJobSearchResults();
            this.state.keywordInputRef.current.focus();
        })
    }

    onResultClick = (hitId) => {

    }

    setBusinessArea = (value: string) => {
        this.setState({ businessArea: value, pageNumber: 1 },
            () => {
                this.onUpdateQuery();
                this.getJobSearchResults();
            });
    }

    setCity = (value: string) => {
        this.setState({ city: value, pageNumber: 1 },
            () => {
                this.onUpdateQuery();
                this.getJobSearchResults();
            });
    }

   
    setStateValue = (value: string) => {
        this.setState({ state: value, pageNumber: 1 },
            () => {
                this.onUpdateQuery();
                this.getJobSearchResults();
            });
    }

    setCountry = (value: string) => {
        this.setState({ country: value, pageNumber: 1 },
            () => {
                this.onUpdateQuery();
                this.getJobSearchResults();
            });
    }

    getJobSearchResults = () => {
        // Get just the selected facets and selected terms
        this.setState({ isLoading: true, hasSearched: true },
            () => {
                this.props.getSearchResults({
                    city: this.state.city,
                    country: this.state.country,
                    state: this.state.state,
                    businessArea: this.state.businessArea,
                    pageSize: this.state.pageSize,
                    pageNumber: this.state.pageNumber,
                    searchText: this.state.searchText
                } as IJobSearchRequest)
                    .fetch
                    .then(() => {
                        this.setState({
                            isLoading: false,
                            fetchError: false,
                        });
                    })
                    .catch(() => {
                        this.setState({ fetchError: true });
                    });
            });
    }

    onSearch = (searchText: string) => {
        this.setState({ pageNumber: 1 }, () => {
            this.getJobSearchResults();
            this.onUpdateQuery();
        });
    }

    setPageNumber = (pageNumber: number) => {
        this.setState({ pageNumber: pageNumber }, () => {
            this.onUpdateQuery();
            this.getJobSearchResults();
            this.state.resultsHeadingRef.current.focus();
        });
    }

    onUpdateQuery = () => {
        const query: { [key: string]: string[] } = {};

        if (this.state.searchText.length > 0) {
            query.q = [this.state.searchText];
        }

        if (this.state.city.length > 0) {
            query.city = [encodeURIComponent(this.state.city)];
        }
        if (this.state.state.length > 0) {
            query.state = [encodeURIComponent(this.state.state)];
        }
        if (this.state.pageNumber) {
            query.pageNumber = [this.state.pageNumber.toString()];
        }
        if (this.state.country) {
            query.country = [encodeURIComponent(this.state.country)];
        }
        if (this.state.businessArea) {
            query.businessArea = [encodeURIComponent(this.state.businessArea)];
        }

        // Update the url
        this.props.setQueryParams(query);
    }

    setErrorState = (value: boolean) => {
        this.setState({ fetchError: value });
    }

    headerSkip = (e: React.PointerEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        this.scrollToResults();
    }

    scrollToResults = () => {
        const navClearance = nav.desktopNavActive() ? nav.desktopShort : nav.mobileShort;
        const targetLocation = this.state.pageContentRef.current.offsetTop - navClearance;
        this.state.pageContentRef.current.focus();
        window.scrollTo(0, targetLocation);
    }
}

const mapStateToProps = (state: IJobSearchAppState): IStateProps => ({
    contentProps: state.contentState.props,
    jobSearchResults: state.searchResults.jobSearchResults,
})

const mapDispatchToProps = (dispatch, ownProps: IOwnProps): IDispatchProps => bindActionCreators({
    getContentProps: () => getContentProps(ownProps.contentId) as any,
    getSearchResults: getJobSearchResults as any,
}, dispatch)


export const JobSearchApp = connect<IStateProps, IDispatchProps, IOwnProps>(mapStateToProps, mapDispatchToProps)(JobSearch);